<template>
  <v-container class="my-10">
    <v-row>
      <v-col cols="12" md="12" class="align-self-center">
        <v-card flat>
          <v-card-text>
            Ini halaman home Dosen!
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'HomeDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
